import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './menu-item/app.menu-item';


@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    templateUrl: './app.menu.html'
})
export class AppMenu {
    model = input<MenuItem[]>([
        // {
        //     items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/'], }]
        // },

        // {
        //     items: [
        //         {

        //             label: 'Reportes',
        //             icon: 'pi pi-fw pi-book',
        //             items: [{
        //                 label: 'Cierre de caja',
        //                 routerLink: ['/reports/cash-closing']
        //             },
        //             {
        //                 label: 'Cierre de sucursal',
        //                 routerLink: ['/reports/branch-closing']
        //             },
        //             ]
        //         }
        //     ]
        // },

        // {
        //     items: [
        //         {

        //             label: 'Administrativos',
        //             icon: 'pi pi-fw pi-users',
        //             items: [{
        //                 label: 'Sucursales',
        //                 routerLink: ['/admin/branches']
        //             },
        //             {
        //                 label: 'Perfiles',
        //                 routerLink: ['/admin/profiles']
        //             },

        //             {
        //                 label: 'Usuarios',
        //                 routerLink: ['/admin/users']
        //             },

        //             ]
        //         }
        //     ]
        // },

        // {
        //     items: [
        //         { label: 'Form Layout', icon: 'pi pi-fw pi-id-card', routerLink: ['/uikit/formlayout'] },
        //         { label: 'Input', icon: 'pi pi-fw pi-check-square', routerLink: ['/uikit/input'] },
        //         { label: 'Button', icon: 'pi pi-fw pi-mobile', class: 'rotated-icon', routerLink: ['/uikit/button'] },
        //         { label: 'Table', icon: 'pi pi-fw pi-table', routerLink: ['/uikit/table'] },
        //         { label: 'List', icon: 'pi pi-fw pi-list', routerLink: ['/uikit/list'] },
        //         { label: 'Tree', icon: 'pi pi-fw pi-share-alt', routerLink: ['/uikit/tree'] },
        //         { label: 'Panel', icon: 'pi pi-fw pi-tablet', routerLink: ['/uikit/panel'] },
        //         { label: 'Overlay', icon: 'pi pi-fw pi-clone', routerLink: ['/uikit/overlay'] },
        //         { label: 'Media', icon: 'pi pi-fw pi-image', routerLink: ['/uikit/media'] },
        //         { label: 'Menu', icon: 'pi pi-fw pi-bars', routerLink: ['/uikit/menu'] },
        //         { label: 'Message', icon: 'pi pi-fw pi-comment', routerLink: ['/uikit/message'] },
        //         { label: 'File', icon: 'pi pi-fw pi-file', routerLink: ['/uikit/file'] },
        //         { label: 'Chart', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/uikit/charts'] },
        //         { label: 'Timeline', icon: 'pi pi-fw pi-calendar', routerLink: ['/uikit/timeline'] },
        //         { label: 'Misc', icon: 'pi pi-fw pi-circle', routerLink: ['/uikit/misc'] }
        //     ]
        // },
        // {
        //     items: [
        //         {
        //             label: 'Landing',
        //             icon: 'pi pi-fw pi-globe',
        //             routerLink: ['/landing']
        //         },
        //         {
        //             label: 'Auth',
        //             icon: 'pi pi-fw pi-user',
        //             items: [
        //                 {
        //                     label: 'Login',
        //                     icon: 'pi pi-fw pi-sign-in',
        //                     routerLink: ['/auth/login']
        //                 },
        //                 {
        //                     label: 'Error',
        //                     icon: 'pi pi-fw pi-times-circle',
        //                     routerLink: ['/auth/error']
        //                 },
        //                 {
        //                     label: 'Access Denied',
        //                     icon: 'pi pi-fw pi-lock',
        //                     routerLink: ['/auth/access']
        //                 }
        //             ]
        //         },
        //         {
        //             label: 'Crud',
        //             icon: 'pi pi-fw pi-pencil',
        //             routerLink: ['/pages/crud']
        //         },
        //         {
        //             label: 'Not Found',
        //             icon: 'pi pi-fw pi-exclamation-circle',
        //             routerLink: ['/pages/notfound']
        //         },
        //         {
        //             label: 'Empty',
        //             icon: 'pi pi-fw pi-circle-off',
        //             routerLink: ['/pages/empty']
        //         }
        //     ]

        // },

        // // {
        // //     label: 'Hierarchy',
        // //     items: [
        // //         {
        // //             label: 'Submenu 1',
        // //             icon: 'pi pi-fw pi-bookmark',
        // //             items: [
        // //                 {
        // //                     label: 'Submenu 1.1',
        // //                     icon: 'pi pi-fw pi-bookmark',
        // //                     items: [
        // //                         { label: 'Submenu 1.1.1', icon: 'pi pi-fw pi-bookmark' },
        // //                         { label: 'Submenu 1.1.2', icon: 'pi pi-fw pi-bookmark' },
        // //                         { label: 'Submenu 1.1.3', icon: 'pi pi-fw pi-bookmark' }
        // //                     ]
        // //                 },
        // //                 {
        // //                     label: 'Submenu 1.2',
        // //                     icon: 'pi pi-fw pi-bookmark',
        // //                     items: [{ label: 'Submenu 1.2.1', icon: 'pi pi-fw pi-bookmark' }]
        // //                 }
        // //             ]
        // //         },
        // //         {
        // //             label: 'Submenu 2',
        // //             icon: 'pi pi-fw pi-bookmark',
        // //             items: [
        // //                 {
        // //                     label: 'Submenu 2.1',
        // //                     icon: 'pi pi-fw pi-bookmark',
        // //                     items: [
        // //                         { label: 'Submenu 2.1.1', icon: 'pi pi-fw pi-bookmark' },
        // //                         { label: 'Submenu 2.1.2', icon: 'pi pi-fw pi-bookmark' }
        // //                     ]
        // //                 },
        // //                 {
        // //                     label: 'Submenu 2.2',
        // //                     icon: 'pi pi-fw pi-bookmark',
        // //                     items: [{ label: 'Submenu 2.2.1', icon: 'pi pi-fw pi-bookmark' }]
        // //                 }
        // //             ]
        // //         }
        // //     ]




        // // },
    ]);

    ngOnInit() {
        // this.model = [
        //     {
        //         items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/'], }]
        //     },

        //     {
        //         items: [
        //             {

        //                 label: 'Reportes',
        //                 icon: 'pi pi-fw pi-book',
        //                 items: [{
        //                     label: 'Cierre de caja',
        //                     routerLink: ['/reports/chash-closing']
        //                 },
        //                 {
        //                     label: 'Cierre de sucursal',
        //                     routerLink: ['/reports/branch-closing']
        //                 },
        //                 ]
        //             }
        //         ]
        //     },

        //     {
        //         items: [
        //             {

        //                 label: 'Administrativos',
        //                 icon: 'pi pi-fw pi-users',
        //                 items: [{
        //                     label: 'Sucursales',
        //                     routerLink: ['/admin/branches']
        //                 },
        //                 {
        //                     label: 'Perfiles',
        //                     routerLink: ['/admin/profiles']
        //                 },

        //                 {
        //                     label: 'Usuarios',
        //                     routerLink: ['/admin/users']
        //                 },

        //                 ]
        //             }
        //         ]
        //     },

        //     {
        //         items: [
        //             { label: 'Form Layout', icon: 'pi pi-fw pi-id-card', routerLink: ['/uikit/formlayout'] },
        //             { label: 'Input', icon: 'pi pi-fw pi-check-square', routerLink: ['/uikit/input'] },
        //             { label: 'Button', icon: 'pi pi-fw pi-mobile', class: 'rotated-icon', routerLink: ['/uikit/button'] },
        //             { label: 'Table', icon: 'pi pi-fw pi-table', routerLink: ['/uikit/table'] },
        //             { label: 'List', icon: 'pi pi-fw pi-list', routerLink: ['/uikit/list'] },
        //             { label: 'Tree', icon: 'pi pi-fw pi-share-alt', routerLink: ['/uikit/tree'] },
        //             { label: 'Panel', icon: 'pi pi-fw pi-tablet', routerLink: ['/uikit/panel'] },
        //             { label: 'Overlay', icon: 'pi pi-fw pi-clone', routerLink: ['/uikit/overlay'] },
        //             { label: 'Media', icon: 'pi pi-fw pi-image', routerLink: ['/uikit/media'] },
        //             { label: 'Menu', icon: 'pi pi-fw pi-bars', routerLink: ['/uikit/menu'] },
        //             { label: 'Message', icon: 'pi pi-fw pi-comment', routerLink: ['/uikit/message'] },
        //             { label: 'File', icon: 'pi pi-fw pi-file', routerLink: ['/uikit/file'] },
        //             { label: 'Chart', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/uikit/charts'] },
        //             { label: 'Timeline', icon: 'pi pi-fw pi-calendar', routerLink: ['/uikit/timeline'] },
        //             { label: 'Misc', icon: 'pi pi-fw pi-circle', routerLink: ['/uikit/misc'] }
        //         ]
        //     },
        //     {
        //         items: [
        //             {
        //                 label: 'Landing',
        //                 icon: 'pi pi-fw pi-globe',
        //                 routerLink: ['/landing']
        //             },
        //             {
        //                 label: 'Auth',
        //                 icon: 'pi pi-fw pi-user',
        //                 items: [
        //                     {
        //                         label: 'Login',
        //                         icon: 'pi pi-fw pi-sign-in',
        //                         routerLink: ['/auth/login']
        //                     },
        //                     {
        //                         label: 'Error',
        //                         icon: 'pi pi-fw pi-times-circle',
        //                         routerLink: ['/auth/error']
        //                     },
        //                     {
        //                         label: 'Access Denied',
        //                         icon: 'pi pi-fw pi-lock',
        //                         routerLink: ['/auth/access']
        //                     }
        //                 ]
        //             },
        //             {
        //                 label: 'Crud',
        //                 icon: 'pi pi-fw pi-pencil',
        //                 routerLink: ['/pages/crud']
        //             },
        //             {
        //                 label: 'Not Found',
        //                 icon: 'pi pi-fw pi-exclamation-circle',
        //                 routerLink: ['/pages/notfound']
        //             },
        //             {
        //                 label: 'Empty',
        //                 icon: 'pi pi-fw pi-circle-off',
        //                 routerLink: ['/pages/empty']
        //             }
        //         ]

        //     },

        //     // {
        //     //     label: 'Hierarchy',
        //     //     items: [
        //     //         {
        //     //             label: 'Submenu 1',
        //     //             icon: 'pi pi-fw pi-bookmark',
        //     //             items: [
        //     //                 {
        //     //                     label: 'Submenu 1.1',
        //     //                     icon: 'pi pi-fw pi-bookmark',
        //     //                     items: [
        //     //                         { label: 'Submenu 1.1.1', icon: 'pi pi-fw pi-bookmark' },
        //     //                         { label: 'Submenu 1.1.2', icon: 'pi pi-fw pi-bookmark' },
        //     //                         { label: 'Submenu 1.1.3', icon: 'pi pi-fw pi-bookmark' }
        //     //                     ]
        //     //                 },
        //     //                 {
        //     //                     label: 'Submenu 1.2',
        //     //                     icon: 'pi pi-fw pi-bookmark',
        //     //                     items: [{ label: 'Submenu 1.2.1', icon: 'pi pi-fw pi-bookmark' }]
        //     //                 }
        //     //             ]
        //     //         },
        //     //         {
        //     //             label: 'Submenu 2',
        //     //             icon: 'pi pi-fw pi-bookmark',
        //     //             items: [
        //     //                 {
        //     //                     label: 'Submenu 2.1',
        //     //                     icon: 'pi pi-fw pi-bookmark',
        //     //                     items: [
        //     //                         { label: 'Submenu 2.1.1', icon: 'pi pi-fw pi-bookmark' },
        //     //                         { label: 'Submenu 2.1.2', icon: 'pi pi-fw pi-bookmark' }
        //     //                     ]
        //     //                 },
        //     //                 {
        //     //                     label: 'Submenu 2.2',
        //     //                     icon: 'pi pi-fw pi-bookmark',
        //     //                     items: [{ label: 'Submenu 2.2.1', icon: 'pi pi-fw pi-bookmark' }]
        //     //                 }
        //     //             ]
        //     //         }
        //     //     ]




        //     // },
        // ];
    }
}
